import { ROUTES } from '../types/global/routes.types';

export const DASHBOARD_HUB_TAB = {
    BUZZBRIDGE: 'buzzbridge',
    CREATOR: 'creator',
} as const;

export type TDashboardHubTab = (typeof DASHBOARD_HUB_TAB)[keyof typeof DASHBOARD_HUB_TAB];

export function parseDashboardHubTab(raw: string | null): TDashboardHubTab {
    return raw === DASHBOARD_HUB_TAB.CREATOR ? DASHBOARD_HUB_TAB.CREATOR : DASHBOARD_HUB_TAB.BUZZBRIDGE;
}

/** Workspace sections inside Creator Dashboard (separate from hub `tab`). */
export const DASHBOARD_SECTION_PARAM = 'section';

export const CREATOR_DASHBOARD_SECTION = {
    OVERVIEW: 'Overview',
    BOOKMARKED_CAMPAIGNS: 'Bookmarked Campaigns',
    CONTEST_SUBMISSIONS: 'Contest Submissions',
    AUDITION_APPLICATIONS: 'Audition Applications',
    AUDITIONS: 'Auditions',
    TICKETS: 'Tickets',
    CAMPAIGNS: 'Campaigns',
    EVENTS: 'Events',
    USERS: 'Users',
    REPORTS: 'Reports',
    REQUESTS: 'Requests',
    PAYOUTS: 'Payouts',
    PROJECTS: 'Projects',
    INFLUENCERS: 'Influencers',
    UGC_CAMPAIGNS: 'UGC Campaigns',
} as const;

/** Legacy `section` query values from before tab rename. */
const CREATOR_SECTION_ALIASES: Record<string, string> = {
    Submissions: CREATOR_DASHBOARD_SECTION.CONTEST_SUBMISSIONS,
    Applications: CREATOR_DASHBOARD_SECTION.AUDITION_APPLICATIONS,
};

const DEFAULT_CREATOR_SECTION = CREATOR_DASHBOARD_SECTION.OVERVIEW;

export function parseDashboardSection(raw: string | null, allowed: string[]): string {
    const normalized = raw ? CREATOR_SECTION_ALIASES[raw] ?? raw : null;
    if (normalized && allowed.includes(normalized)) return normalized;
    if (allowed.includes(DEFAULT_CREATOR_SECTION)) return DEFAULT_CREATOR_SECTION;
    return allowed[0] ?? DEFAULT_CREATOR_SECTION;
}

export function dashboardHubPath(tab: TDashboardHubTab = DASHBOARD_HUB_TAB.BUZZBRIDGE, section?: string): string {
    const params = new URLSearchParams({ tab });
    if (tab === DASHBOARD_HUB_TAB.CREATOR && section) {
        params.set(DASHBOARD_SECTION_PARAM, section);
    }
    return `${ROUTES.DASHBOARD}?${params.toString()}`;
}

export function dashboardCreatorSectionPath(section: string): string {
    return dashboardHubPath(DASHBOARD_HUB_TAB.CREATOR, section);
}
